export default __webpack_public_path__ + "static/media/u1.3f5d0428.svg";